// Mock数据 - 启派云智科技公司
export const companyInfo = {
  name: "深圳启派云智科技有限公司",
  brandName: "启派云智",
  slogan: "智启未来，云创无限",
  description: "专业的云智能解决方案提供商，致力于为企业提供先进的云计算、人工智能和大数据技术服务",
  address: "深圳市南山区科技园南区软件产业基地",
  phone: "400-888-9999",
  email: "contact@pi-cloud.com",
  website: "www.pi-cloud.com"
};

export const carouselData = [
  {
    id: 1,
    title: "启派云智",
    subtitle: "智启未来，云创无限",
    description: "专业的云智能解决方案提供商，致力于为企业提供先进的云计算、人工智能和大数据技术服务",
    backgroundImage: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80",
    gradient: "linear-gradient(135deg, rgba(102, 126, 234, 0.8) 0%, rgba(118, 75, 162, 0.8) 100%)"
  },
  {
    id: 2,
    title: "云计算服务",
    subtitle: "弹性可靠的云基础设施",
    description: "提供稳定可靠的云基础设施服务，包括云服务器、云存储、云网络等全方位云计算解决方案",
    backgroundImage: "https://images.unsplash.com/photo-1629904853716-f0bc54eea481?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80",
    gradient: "linear-gradient(135deg, rgba(20, 30, 48, 0.8) 0%, rgba(36, 59, 85, 0.8) 100%)"
  },
  {
    id: 3,
    title: "人工智能",
    subtitle: "智能化解决方案",
    description: "基于深度学习和机器学习技术，为企业提供智能化解决方案，包括智能客服、图像识别、语音识别等",
    backgroundImage: "https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80",
    gradient: "linear-gradient(135deg, rgba(129, 69, 191, 0.8) 0%, rgba(76, 29, 149, 0.8) 100%)"
  },
  {
    id: 4,
    title: "大数据分析",
    subtitle: "数据驱动的商业洞察",
    description: "专业的大数据处理和分析服务，帮助企业从海量数据中挖掘价值，实现数据驱动的决策",
    backgroundImage: "https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80",
    gradient: "linear-gradient(135deg, rgba(59, 130, 246, 0.8) 0%, rgba(37, 99, 235, 0.8) 100%)"
  }
];

export const services = [
  {
    id: 1,
    title: "云计算服务",
    description: "提供稳定可靠的云基础设施服务，包括云服务器、云存储、云网络等全方位云计算解决方案",
    icon: "cloud",
    features: ["弹性伸缩", "高可用", "安全可靠", "按需付费"]
  },
  {
    id: 2,
    title: "人工智能",
    description: "基于深度学习和机器学习技术，为企业提供智能化解决方案，包括智能客服、图像识别、语音识别等",
    icon: "robot",
    features: ["智能分析", "自动化处理", "深度学习", "精准识别"]
  },
  {
    id: 3,
    title: "大数据分析",
    description: "专业的大数据处理和分析服务，帮助企业从海量数据中挖掘价值，实现数据驱动的决策",
    icon: "database",
    features: ["实时分析", "数据挖掘", "可视化报告", "预测建模"]
  },
  {
    id: 4,
    title: "数字化转型",
    description: "为传统企业提供全面的数字化转型咨询和实施服务，助力企业在数字化时代保持竞争优势",
    icon: "transformation",
    features: ["战略规划", "技术咨询", "系统集成", "培训支持"]
  }
];

export const products = [
  {
    id: 1,
    name: "启派云平台",
    description: "一站式云计算管理平台，提供云资源管理、监控、自动化运维等功能",
    image: "/api/placeholder/300/200",
    price: "¥999/月起"
  },
  {
    id: 2,
    name: "智能数据分析系统",
    description: "基于AI的数据分析平台，支持多种数据源接入和智能分析算法",
    image: "/api/placeholder/300/200",
    price: "¥1999/月起"
  },
  {
    id: 3,
    name: "企业数字化套件",
    description: "包含OA、CRM、ERP等多个模块的一体化企业管理解决方案",
    image: "/api/placeholder/300/200",
    price: "¥4999/月起"
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "张明",
    position: "首席技术官",
    description: "15年云计算和大数据领域经验，曾任职于腾讯、阿里巴巴等知名企业",
    avatar: "/api/placeholder/150/150"
  },
  {
    id: 2,
    name: "李小华",
    position: "产品总监",
    description: "10年产品管理经验，专注于B2B SaaS产品设计和用户体验优化",
    avatar: "/api/placeholder/150/150"
  },
  {
    id: 3,
    name: "王强",
    position: "AI研究总监",
    description: "博士学位，专注于机器学习和深度学习算法研究，发表多篇顶级论文",
    avatar: "/api/placeholder/150/150"
  },
  {
    id: 4,
    name: "陈丽",
    position: "商务总监",
    description: "8年企业服务经验，成功服务500+企业客户，擅长解决方案设计",
    avatar: "/api/placeholder/150/150"
  }
];

export const caseStudies = [
  {
    id: 1,
    clientName: "某大型制造企业",
    industry: "制造业",
    challenge: "传统IT架构无法支撑业务快速发展，数据孤岛严重",
    solution: "为客户设计了云原生架构，实现了系统整合和数据统一管理",
    results: ["IT成本降低40%", "业务处理效率提升60%", "数据处理能力提升300%"]
  },
  {
    id: 2,
    clientName: "某知名电商平台",
    industry: "电子商务",
    challenge: "高并发场景下系统不稳定，用户体验差",
    solution: "采用微服务架构和智能负载均衡，构建高可用电商系统",
    results: ["系统稳定性提升99.9%", "响应速度提升50%", "用户满意度提升35%"]
  },
  {
    id: 3,
    clientName: "某金融科技公司",
    industry: "金融科技",
    challenge: "数据安全要求高，需要满足合规要求",
    solution: "提供金融级安全解决方案，包括数据加密、访问控制等",
    results: ["通过金融合规认证", "数据泄露风险降低95%", "审计效率提升80%"]
  }
];

export const companyStats = [
  { label: "服务客户", value: "500+", unit: "家" },
  { label: "项目经验", value: "1000+", unit: "个" },
  { label: "技术专家", value: "100+", unit: "名" },
  { label: "服务时长", value: "24/7", unit: "小时" }
];

export const news = [
  {
    id: 1,
    title: "启派云智荣获2023年度最佳云服务提供商奖",
    date: "2023-12-15",
    summary: "在2023年云计算产业峰会上，启派云智凭借卓越的技术实力和优质的服务获得最佳云服务提供商奖...",
    image: "/api/placeholder/300/200"
  },
  {
    id: 2,
    title: "启派云智与某知名大学达成战略合作",
    date: "2023-11-28",
    summary: "双方将在人工智能、大数据等领域开展深度合作，共同培养高端技术人才...",
    image: "/api/placeholder/300/200"
  },
  {
    id: 3,
    title: "启派云智新产品发布会成功举办",
    date: "2023-10-20",
    summary: "发布了新一代智能数据分析平台，为企业数字化转型提供更强大的技术支撑...",
    image: "/api/placeholder/300/200"
  }
];